// const SmartPhone = require('detect-mobile-browser')(false);

class UserAgent {
  isMobile () {
    return true;
    // return SmartPhone.isAny()
  }
}

const instance = new UserAgent()

export default instance
